import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CuentaBancoQuery } from 'src/app/shared/interfaces';

export interface CambiarCuentaBancariaDialogData {
  egresoId: string;
  cuentaActualId?: string;
  cuentaActualNombre?: string;
  cuentaActualTipo?: string;
  cuentas: CuentaBancoQuery[];
}

@Component({
  selector: 'app-cambiar-cuenta-bancaria',
  templateUrl: './cambiar-cuenta-bancaria.component.html',
  styleUrl: './cambiar-cuenta-bancaria.component.scss',
})
export class CambiarCuentaBancariaComponent {
  readonly cuentaControl = new FormControl<string | null>(null, {
    validators: [Validators.required],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: CambiarCuentaBancariaDialogData,
    private readonly dialogRef: MatDialogRef<CambiarCuentaBancariaComponent>,
  ) {}

  get cuentasDisponibles(): CuentaBancoQuery[] {
    const currentType = this.data.cuentaActualTipo?.trim().toUpperCase();
    return this.data.cuentas.filter(
      (cuenta) =>
        cuenta.id !== this.data.cuentaActualId &&
        cuenta.tipo?.trim().toUpperCase() === currentType,
    );
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.cuentaControl.invalid || !this.cuentaControl.value) {
      this.cuentaControl.markAsTouched();
      return;
    }

    this.dialogRef.close({ cuentaBancoId: this.cuentaControl.value });
  }
}
